export const waitForIntroduction = async () =>
    await Promise.all(
        document.getAnimations().map(animation => animation.finished)
    );

export const clearLoader = async () => {
    const $loader = document.querySelector(".app-loader");

    document.body.style.setProperty("position", "fixed");

    const animation = $loader.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 500,
        easing: "cubic-bezier(0.11, 0, 0.5, 0)",
        fill: "forwards"
    });

    await animation.finished;

    $loader.remove();

    document.body.style.removeProperty("position");
};
